<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12"> 
                <v-text-field
                    label="Account Name"
                    dense
                    outlined
                    hide-details="auto"
                    :rules="[isRequired]"
                    v-model="form.name"
                >
               </v-text-field>
           </v-col>
       </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    label="Currency"
                    v-model="form.currency_id"
                    :rules="[isRequired]"
                    outlined
                    dense
                    hide-details="auto"
                    :items="currencies"
                    item-value="id"
                    item-text="display_name"
                    @update:search-input="searchCurency"
                    prepend-inner-icon="mdi-magnify"
                    :loading="currencyLoading"
                >

                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    label="Supplier"
                    :items="suppliers"
                    item-value="id"
                    item-text="display_name"
                    v-model="form.supplier_id"
                    @update:search-input="searchSuppliers"
                    :disabled="!!supplierId"
                    outlined
                    prepend-inner-icon="mdi-magnify"
                    dense
                    hide-details="auto"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" >
                <v-autocomplete
                    label="Ladger Payable"
                    v-model="form.ledger_payable_id"
                    :rules="[isRequired]"
                    dense
                    outlined
                    hide-details="auto"
                    :items="ledgerAccounts"
                    item-value="id"
                    item-text="display_name"
                    @update:search-input="searchLedgerAccount"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from "./../../utils/validations";
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "SupplierAccountForm",
    props: {
        supplierId: Number,
        value: Object
    },
    data() {
        return {
            id: null,
            loading: false,
            form: {
                supplier_id: null,
                name: "",
                currency_id: null,
                ledger_payable_id: null
            }
        }
    },
    computed: {
        ...mapGetters({
            currencies: "purchase/currency/list",
            currencyLoading: "purchase/currency/loading",
            ledgerAccounts: "purchase/ledgerAccount/list",
            suppliers: "purchase/supplier/list"
        })
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            } 
        }
    },
    methods: {
        isRequired,
        ...mapActions({
            searchCurency: "purchase/currency/search",
            searchLedgerAccount: "purchase/ledgerAccount/search",
            searchSuppliers: "purchase/supplier/search"
        }),
        submit() {
            if(!this.$refs.form.validate()) return;
            this.$emit("submit", this.form)
        }
    },
    mounted() {
        if(this.supplierId) {
            this.form.supplier_id = this.supplierId;
        }
        if(this.value) {
            this.form = {...this.form, ...this.value}
        }
    }
}
</script>

<style>

</style>